import getConfig from 'next/config';

const isDebug = getConfig().publicRuntimeConfig.antiFraudDebug;

export const gib = {
  setIsAuthorized: () => {
    if (typeof window.gib?.setAuthStatus === 'function') {
      window.gib.setAuthStatus(window.gib.IS_AUTHORIZED);
      isDebug && console.log(`Group IB setAuthStatus with value=${window.gib.IS_AUTHORIZED}`);
    }
  },
  setLogin: (value: any) => {
    if (typeof window.gib?.setLogin === 'function') {
      window.gib.setLogin(value);
      isDebug && console.log(`Group IB setLogin with value=${value}`);
    }
  },
  setAttribute: (name: string, value: string) => {
    if (typeof window.gib?.setAttribute === 'function') {
      window.gib.setAttribute(name, value);
      isDebug && console.log(`Group IB setAttribute with name=${name}, value=${value}`);
    }
  },
  setSessionID: (value: string) => {
    if (typeof window.gib?.setSessionID === 'function') {
      window.gib.setSessionID(value);
      isDebug && console.log(`Group IB setSessionID with value=${value}`);
    }
  },
};
